import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';

export default function MainLayout() {
  return (
    <div className="min-h-full">
      <Navigation />
      <Outlet />
    </div>
  );
}
